import { Button, Card, Modal, Text } from "../../../../components";
import Localization from "../../../../localization";
import Introduction from "./introduction";
import React, { useRef } from "react";
import Recipients from "./recipients";
import Inactive from "./inactive";
import Options from "./options";
import { Flex } from "antd";

const AlarmSMS = ({ title = Localization.general.alarmSMS, ...props }) => {
  const optionsModalRef = useRef();

  return (
    <>
      <Card title={title} {...props}>
        <Text
          weight={400}
          type="secondary"
          children={Localization.service.alarmSMS_desc}
        />
        <Recipients className="m-30-v" />
        <Flex gap={"1rem"} wrap="wrap">
          <Button
            type="primary"
            title={Localization.general.more_options}
            onClick={() => optionsModalRef.current.open()}
          />
          <Button
            title={Localization.general.about_service}
            onClick={() => window.open(props?.readMoreUrl)}
          />
        </Flex>
      </Card>
      <Modal title={Localization.general.alarmSMS} ref={optionsModalRef}>
        <Options onDone={() => optionsModalRef.current.close()} />
      </Modal>
    </>
  );
};

AlarmSMS.Introduction = Introduction;
AlarmSMS.Inactive = Inactive;

export default AlarmSMS;
